import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { WarningAlert } from "../ui";
import { get } from "../../crud/patio.crud";
import { PERMISSIONS } from "../../utils/Permissions";
import { hasPermission } from "../../utils/Utils";
import { EVENTO_LOCALIZACAO_ATUALIZADA, temLocalizacaoExata } from "../../utils/localizacao";
import styles from "./LocalizacaoPendenteAlert.module.css";

export default function LocalizacaoPendenteAlert() {
	const permissions = useSelector((state) => state.auth.permissions);
	const podeDefinirLocalizacao = hasPermission(permissions, PERMISSIONS.PATIO_UPDATE_LOCATION);
	const [localizacaoPendente, setLocalizacaoPendente] = useState(false);

	const verificarLocalizacao = useCallback(() => {
		get()
			.then(({ data }) => {
				const patio = data?.data;
				setLocalizacaoPendente(Boolean(patio) && !temLocalizacaoExata(patio.pat_latitude, patio.pat_longitude));
			})
			.catch(() => {});
	}, []);

	useEffect(() => {
		if (!podeDefinirLocalizacao) return undefined;

		verificarLocalizacao();
		window.addEventListener(EVENTO_LOCALIZACAO_ATUALIZADA, verificarLocalizacao);

		return () => window.removeEventListener(EVENTO_LOCALIZACAO_ATUALIZADA, verificarLocalizacao);
	}, [podeDefinirLocalizacao, verificarLocalizacao]);

	if (!podeDefinirLocalizacao || !localizacaoPendente) {
		return null;
	}

	return (
		<WarningAlert className={styles.wrapper}>
			<span>Defina a localização do pátio no mapa para orientar os motoristas e acompanhar a localização dos motoristas.</span>
			<Link to="/meu-patio" className={styles.botaoDefinir}>Definir localização</Link>
		</WarningAlert>
	);
}
